import React from "react";
import { Settings, Mail } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "../ui/popover";
import { Button } from "../ui/button";
import { AuthContext } from "../../providers/Auth";

function SettingsMenu() {
    const { user, signInWithEmail, signOut, isSupabaseConfigured, isAuthReady } =
        React.useContext(AuthContext);
    const [email, setEmail] = React.useState("");
    const [statusMessage, setStatusMessage] = React.useState("");
    const [isSubmitting, setIsSubmitting] = React.useState(false);


    async function handleSubmit(e) {
        e.preventDefault();
        if (!email) return;
        setIsSubmitting(true);
        try {
            await signInWithEmail(email);
            setStatusMessage("Magic link sent. Check your email.");
            setEmail("");
        } catch (err) {
            setStatusMessage(
                isSupabaseConfigured
                    ? "Could not start login, please try again."
                    : "Supabase is not configured yet."
            );
        } finally {
            setIsSubmitting(false);
        }
    }



    return (
        <Popover>
            <PopoverTrigger asChild>
                <button className="p-2 rounded-lg hover:bg-slate-800/60 transition-colors">
                    <Settings size={20} className="text-slate-300" />
                </button>
            </PopoverTrigger>
            <PopoverContent
                align="end"
                className="bg-slate-900/95 border-slate-700 rounded-xl p-4 w-80 shadow-2xl backdrop-blur-sm"
            >
                <div className="space-y-4">
                    {/* Auth Section */}
                    {isSupabaseConfigured && (
                        <div className="space-y-2">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-xs uppercase text-slate-400 tracking-[0.15em]">
                                        Account
                                    </p>
                                    <p className="text-white text-sm font-medium">
                                        {user ? user.email : "Not signed in"}
                                    </p>
                                </div>
                                {user && (
                                    <Button variant="secondary" size="sm" onClick={signOut}>
                                        Sign out
                                    </Button>
                                )}
                            </div>
                            {!user && (
                                <form className="space-y-2" onSubmit={handleSubmit}>
                                    <label className="flex items-center gap-2 text-xs text-slate-300">
                                        <Mail size={14} />
                                        One Time Email Link
                                    </label>
                                    <input
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="you@example.com"
                                        className="w-full bg-slate-800 text-white px-3 py-2 rounded-lg border border-slate-700 focus:outline-none focus:ring-2 focus:ring-white/20 text-sm"
                                    />
                                    <Button
                                        type="submit"
                                        variant="submit"
                                        size="sm"
                                        className="w-full"
                                        disabled={!isAuthReady || isSubmitting}
                                    >
                                        {isSubmitting ? "Sending..." : "Send Link"}
                                    </Button>
                                    {statusMessage && (
                                        <p className="text-xs text-slate-300">{statusMessage}</p>
                                    )}
                                </form>
                            )}
                        </div>
                    )}
                </div>
            </PopoverContent>
        </Popover>
    );
}

export default SettingsMenu;
